import { FC } from 'react';
import { AlertTriangle } from 'react-feather';
import styled from 'styled-components';
import { theme } from '../../theme';

type AlertProps = {
  message: string;
  title: string;
};

const AlertContainer = styled.div`
  align-items: center;
  background-color: #fff0b3;
  border-radius: 4px;
  color: ${theme.colors.primary};
  font-size: 0.8em;
  margin-bottom: 10px;
  padding: 9px;
  width: 100%;
`;

const SubContainer = styled.div`
  padding-left: 2%;
`;

const Header = styled.div`
  margin-bottom: 2px;
`;

const Title = styled.strong`
  margin-left: 7px;
  font-size: 1.2em;
`;

const AlertComponent: FC<AlertProps> = ({ message, title }) => {
  return (
    <AlertContainer>
      <SubContainer>
        <Header>
          <AlertTriangle size={15} color={theme.colors.primary} />
          <Title>{title}</Title>
        </Header>

        <div>
          {message.split('\n').map((i, key) => {
            if (!i.length) return <br key={key} />;

            return <div key={key}>{i}</div>;
          })}
        </div>
      </SubContainer>
    </AlertContainer>
  );
};

export default AlertComponent;
